__turbopack_context__.v({
  "container": "d-EJaW_container",
  "cta": "d-EJaW_cta",
  "padlock": "d-EJaW_padlock",
  "textBody": "d-EJaW_textBody",
  "title": "d-EJaW_title",
});
